import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIx2000biListStatus: 'idle',
    loadIx2000biListError: undefined as any,
    loadIx2000biListLastArgs: undefined as any,
    loadIx2000biStatus: 'idle',
    loadIx2000biError: undefined as any,
    saveIx2000biStatus: 'idle',
    saveIx2000biError: undefined as any,
    deleteIx2000biStatus: 'idle',
    deleteIx2000biError: undefined as any,

    ix2000biList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2000biList = createAsyncThunk('ix2000biSlice/loadIx2000biList', async ({ gridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2000biSlice.loadIx2000biListLastArgs
    if (_.isEqual(lastArgs, { gridFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_getbuvorgangbiitemsdata/?NBUVORGANGTYP=${gridFilters.values.NBUVORGANGTYPFILTER}&LFREMDBUKREISNR=${gridFilters.values.LFREMDBUKREISNRFILTER}&NFREMDYEAR=${gridFilters.values.NFREMDYEARFILTER}&LFREMDBUNR=${gridFilters.values.LFREMDBUNRFILTER}&NUSEBUMAPFILTER=${gridFilters.values.NUSEBUMAPFILTERFILTER}&NONLYCOUNT=${gridFilters.values.NONLYCOUNTFILTER}`, undefined)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2000biListStatus } = getState().ix2000biSlice
        return loadIx2000biListStatus !== 'pending'
    }
})

export const loadIx2000bi = createAsyncThunk('ix2000biSlice/loadIx2000bi', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ix2000bi/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2000biStatus } = getState().ix2000biSlice
        return loadIx2000biStatus !== 'pending'
    }
})

export const saveIx2000bi = createAsyncThunk('ix2000biSlice/saveIx2000bi', async ({ ix2000bi }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ix2000bi?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ix2000bi/${ ix2000bi?.HDR_ID }/`,
            prepareData(ix2000bi),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ix2000bi/`,
            prepareData(ix2000bi),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx2000biStatus } = getState().ix2000biSlice
        return saveIx2000biStatus !== 'pending'
    }
})

export const deleteIx2000bi = createAsyncThunk('ix2000biSlice/deleteIx2000bi', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ix2000bi/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx2000biStatus } = getState().ix2000biSlice
        return deleteIx2000biStatus !== 'pending'
    }
})

const Ix2000biSlice = createSlice({
    name: 'ix2000biSlice',
    initialState,
    reducers: {
        resetloadIx2000biListError: (state) => {
            state.loadIx2000biListError = undefined
        },
        resetloadIx2000bi: (state) => {
            state.formItem = undefined
            state.loadIx2000biError = undefined
        },
        resetloadIx2000biError: (state) => {
            state.loadIx2000biError = undefined
        },
        resetsaveIx2000bi: (state) => {
            state.formItem = undefined
            state.saveIx2000biError = undefined
        },
        resetsaveIx2000biError: (state) => {
            state.saveIx2000biError = undefined
        },
        resetdeleteIx2000biError: (state) => {
            state.deleteIx2000biError = undefined
        },
        removeFromIx2000biListById: (state, action) => {
            state.ix2000biList = state.ix2000biList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2000biListByIds: (state, action) => {
            state.ix2000biList = state.ix2000biList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2000biList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2000biListStatus = 'preloaded'
            state.loadIx2000biListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2000biList = []
            state.loadIx2000biListStatus = 'idle'
            state.loadIx2000biListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2000biList.pending, (state) => {
            state.loadIx2000biListStatus = 'pending'
            state.loadIx2000biListError = undefined
        })
        builder.addCase(loadIx2000biList.fulfilled, (state, action) => {
            state.loadIx2000biListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2000biListLastArgs = action.payload.args

            {
                state.ix2000biList = action.payload.data

            }
        })
        builder.addCase(loadIx2000biList.rejected, (state, action) => {
            state.loadIx2000biListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2000biListError = action.error.message
            } else {
                state.loadIx2000biListError = action.payload
            }
        })

        builder.addCase(loadIx2000bi.pending, (state) => {
            state.loadIx2000biStatus = 'pending'
            state.loadIx2000biError = undefined
        })
        builder.addCase(loadIx2000bi.fulfilled, (state, action) => {
            state.loadIx2000biStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2000biList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2000biList.push(newItem) }
                else { state.ix2000biList[i] = { ...state.ix2000biList[i], ...newItem } }
            }
        })
        builder.addCase(loadIx2000bi.rejected, (state, action) => {
            state.loadIx2000biStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2000biError = action.error.message
            } else {
                state.loadIx2000biError = action.payload
            }
        })

        builder.addCase(saveIx2000bi.pending, (state) => {
            state.saveIx2000biStatus = 'pending'
            state.saveIx2000biError = undefined
        })
        builder.addCase(saveIx2000bi.fulfilled, (state, action) => {
            state.saveIx2000biStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2000biList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2000biList.push(newItem) }
                else { state.ix2000biList[i] = { ...state.ix2000biList[i], ...newItem } }
            }
        })
        builder.addCase(saveIx2000bi.rejected, (state, action) => {
            state.saveIx2000biStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx2000biError = action.error.message
            } else {
                state.saveIx2000biError = action.payload
            }
        })

        builder.addCase(deleteIx2000bi.pending, (state) => {
            state.deleteIx2000biStatus = 'pending'
            state.deleteIx2000biError = undefined
        })
        builder.addCase(deleteIx2000bi.fulfilled, (state, action) => {
            state.deleteIx2000biStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix2000biList = state.ix2000biList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix2000biList = state.ix2000biList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx2000bi.rejected, (state, action) => {
            state.deleteIx2000biStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx2000biError = action.error.message
            } else {
                state.deleteIx2000biError = action.payload
            }
        })

    }
})

export const {
    resetloadIx2000biListError,
    resetloadIx2000bi,
    resetloadIx2000biError,
    resetsaveIx2000bi,
    resetsaveIx2000biError,
    resetdeleteIx2000biError,
    removeFromIx2000biListById,
    removeFromIx2000biListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2000biSlice.actions
export default Ix2000biSlice.reducer
